import React from "react";

const QuantityTransferredIcon = ({ width, height, color }) => {
	return (
		<svg
			width={width || "31"}
			height={height || "31"}
			viewBox="0 0 31 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.11468 12.1182H2.79664C1.2521 12.1182 0 13.3589 0 14.8894V28.2287C0 29.7592 1.2521 30.9999 2.79664 30.9999H6.11468C7.65922 30.9999 8.91131 29.7592 8.91131 28.2287V14.8894C8.91131 13.3589 7.65922 12.1182 6.11468 12.1182Z"
				fill="#435CFF"
			/>
			<path
				d="M17.1117 0H13.7937C12.2492 0 10.9971 1.24071 10.9971 2.7712V28.2287C10.9971 29.7591 12.2492 30.9999 13.7937 30.9999H17.1117C18.6563 30.9999 19.9084 29.7591 19.9084 28.2287V2.7712C19.9084 1.24071 18.6563 0 17.1117 0Z"
				fill="#435CFF"
			/>
			<path
				d="M28.2035 6.85742H24.8855C23.341 6.85742 22.0889 8.09813 22.0889 9.62862V28.2285C22.0889 29.759 23.341 30.9997 24.8855 30.9997H28.2035C29.7481 30.9997 31.0002 29.759 31.0002 28.2285V9.62862C31.0002 8.09813 29.7481 6.85742 28.2035 6.85742Z"
				fill="#435CFF"
			/>
		</svg>
	);
};

export default QuantityTransferredIcon;
